import React from 'react';
import SpecificTabUsrPer from './SpecificTabUsrPer';

let SpecificTabUsr = (props) => {
  let usr = props.usr;
  return (
    <ul>
    {
      Object.keys(usr).map(key => {
        return (
          <li key={key}>
            {usr[key].name}
            <SpecificTabUsrPer 
              edit={usr[key].edit} 
              view={usr[key].view} 
              id={usr[key].id} 
              changeUsrPer={props.changeUsrPer}/>
          </li>
        )
      })
    }
    </ul>
  )
}

export default SpecificTabUsr;


// WEBPACK FOOTER //
// ./src/Components/Admin/Tab/SpecificTabUsr.js